import { HiMinus, HiOutlineViewGrid } from "react-icons/hi";
import { MdFullscreen, MdFullscreenExit } from "react-icons/md";
import { css } from "../../../styled-system/css";
import { HStack } from "../../../styled-system/jsx";
import { useTranslation } from "react-i18next";

const ChatHeader = ({
  conversation,
  isFullScreen = false,
  onToggleFullScreen,
  onClose,
  showConversationsToggle = false,
  onToggleConversations,
  showConversations = false,
}) => {
  const { t } = useTranslation(["chat"]);
  return (
    <HStack
      justifyContent="space-between"
      alignItems="center"
      width="100%"
      padding="10px"
      className={css({
        backgroundColor: "white",
        borderBottom: "1px solid #ddd",
        minHeight: "50px",
      })}
    >
      <div
        className={css({
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          fontSize: "14px",
          fontWeight: "bold",
          color: "black",
          padding: "5px",
          textAlign: "left",
          flexGrow: 1,
          minWidth: 0, // Important for text truncation in flex containers
        })}
      >
        {conversation?.title || t(($) => $.chat["New Conversation"])}
      </div>

      <HStack gap="1">
        {showConversationsToggle && (
          <button
            className={css({
              backgroundColor: showConversations ? "#f0f0f0" : "white",
              fontSize: "18px",
              fontWeight: "bold",
              color: "black",
              borderRadius: "4px",
              width: "30px",
              height: "30px",
              border: isFullScreen ? "none" : "1px solid #ddd",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              _hover: {
                backgroundColor: "#f0f0f0",
              },
            })}
            onClick={onToggleConversations}
            title={t(($) => $.chat["Toggle Conversations"])}
          >
            <HiOutlineViewGrid />
          </button>
        )}

        {onToggleFullScreen && (
          <button
            className={css({
              backgroundColor: "white",
              fontSize: "18px",
              fontWeight: "bold",
              color: "black",
              borderRadius: "4px",
              width: "30px",
              height: "30px",
              border: isFullScreen ? "none" : "1px solid #ddd",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              _hover: {
                backgroundColor: "#f0f0f0",
              },
            })}
            onClick={onToggleFullScreen}
            title={isFullScreen ? t(($) => $.chat["Exit Full Screen"]) : t(($) => $.chat["Full Screen"])}
          >
            {isFullScreen ?
              <MdFullscreenExit />
            : <MdFullscreen />}
          </button>
        )}

        <button
          className={css({
            backgroundColor: "white",
            fontSize: "18px",
            fontWeight: "bold",
            color: "black",
            borderRadius: "4px",
            width: "30px",
            height: "30px",
            border: isFullScreen ? "none" : "1px solid #ddd",
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            _hover: {
              backgroundColor: "#f0f0f0",
            },
          })}
          onClick={onClose}
          title={isFullScreen ? t(($) => $.chat["Close Chat"]) : t(($) => $.chat["Minimize Chat"])}
        >
          <HiMinus />
        </button>
      </HStack>
    </HStack>
  );
};

export default ChatHeader;
